module.exports = __webpack_public_path__ + "media/images/edit-with-pen-24651cd849e7286cb4950337efccc4d8.svg";